<template>
  <div class="max-w-4xl mx-auto">
    <Head title="Política de Privacidad" />
    <h1 class="mb-8 text-3xl font-bold">Política de Privacidad</h1>

    <div class="prose prose-lg max-w-none">
      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">1. Información que Recopilamos</h2>
        <p class="text-gray-600">
          Recopilamos información que usted nos proporciona directamente, incluyendo:
        </p>
        <ul class="list-disc pl-6 text-gray-600 mt-2">
          <li>Información de la cuenta (nombre, correo electrónico, número de teléfono)</li>
          <li>Información de la empresa (nombre, dirección, datos fiscales)</li>
          <li>Datos de transacciones y operaciones comerciales</li>
          <li>Información de inventario y productos</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">2. Uso de la Información</h2>
        <p class="text-gray-600">
          Utilizamos la información recopilada para:
        </p>
        <ul class="list-disc pl-6 text-gray-600 mt-2">
          <li>Proporcionar y mantener nuestros servicios</li>
          <li>Procesar transacciones y gestionar su cuenta</li>
          <li>Enviar notificaciones importantes sobre el servicio</li>
          <li>Mejorar y personalizar su experiencia</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">3. Protección de Datos</h2>
        <p class="text-gray-600">
          Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales contra acceso no autorizado, pérdida o alteración.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">4. Compartir Información</h2>
        <p class="text-gray-600">
          No vendemos ni alquilamos su información personal a terceros. Solo compartimos información cuando:
        </p>
        <ul class="list-disc pl-6 text-gray-600 mt-2">
          <li>Es necesario para proporcionar el servicio</li>
          <li>Lo requiere la ley</li>
          <li>Usted nos da su consentimiento explícito</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">5. Sus Derechos</h2>
        <p class="text-gray-600">
          Usted tiene derecho a:
        </p>
        <ul class="list-disc pl-6 text-gray-600 mt-2">
          <li>Acceder a sus datos personales</li>
          <li>Corregir información inexacta</li>
          <li>Solicitar la eliminación de sus datos</li>
          <li>Oponerse al procesamiento de sus datos</li>
        </ul>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">6. Cookies y Tecnologías Similares</h2>
        <p class="text-gray-600">
          Utilizamos cookies y tecnologías similares para mejorar su experiencia en nuestro sitio web y proporcionar funcionalidades esenciales.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">7. Cambios en la Política</h2>
        <p class="text-gray-600">
          Nos reservamos el derecho de modificar esta política de privacidad en cualquier momento. Le notificaremos sobre cualquier cambio significativo.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-2xl font-semibold mb-4">8. Contacto</h2>
        <p class="text-gray-600">
          Si tiene preguntas sobre esta política de privacidad o sobre cómo manejamos sus datos, puede contactarnos a través de nuestro Centro de Ayuda o por WhatsApp.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script> 